export enum Step {
  // left: Meet your new AI collaborators, right: Grammarly Only
  GrammarlyOnly = '1.grammarly-only',
  // left: Meet your new AI collaborators, right: Full Bench
  FullBench = '2.full-bench',
  // left: show Agents Go page, right: focus on Go
  AgentsGo = '3.agents-go',
  // left: show Proofreader page, right: focus on Proofreader
  Proofreader = '4.proofreader',
  // left: show Plus view, right: hover over all other agents until plus
  Plus = '5.plus',
  // left: show Use agent skills anywhere, right: animate to notch
  UseAgentSkillAnyWhere = '6.use-agent-skill-anywhere',
  // left: show Go Time, right: focus on Go Time
  GoTime = '7.go-time',
}
